import { For, Show } from "solid-js";
import { MAP_EVIDENCE_KIND } from "../../enums/map";
import { journeyIssueTitle } from "../scan/journeyFriction";
import { mapEvidenceLabel } from "./mapEvidenceLabels";
import type { MapPreviewAction } from "./mapPreviewActions";

export function MapActionEvidence(props: {
  action: MapPreviewAction;
  websiteId: string;
}) {
  const structuralEvidence = () =>
    props.action.change.evidence.filter(
      (evidence) => evidence.kind !== MAP_EVIDENCE_KIND.ISSUE,
    );
  const representedPageIds = () =>
    new Set(props.action.change.pages.map((page) => page.id));
  const issuePageCount = (issue: MapPreviewAction["causalIssues"][number]) =>
    new Set(
      issue.pages
        .filter((page) => representedPageIds().has(page.pageId))
        .map((page) => page.pageId),
    ).size;
  return (
    <>
      <Show when={props.action.causalIssues.length > 0}>
        <section class="map-selected-section">
          <h3>Causal action evidence</h3>
          <p>
            These findings directly support this draft action and determine its
            displayed severity.
          </p>
          <ul class="map-selected-evidence">
            <For each={props.action.causalIssues}>
              {(issue) => (
                <li class="is-issue">
                  <strong>{journeyIssueTitle(issue)}</strong>
                  <p>
                    {severityLabel(issue.severity)} finding linked to{" "}
                    {issuePageCount(issue)} represented{" "}
                    {issuePageCount(issue) === 1 ? "page" : "pages"}.
                  </p>
                  <a href={`/w/${props.websiteId}/scan/issues/${issue.id}`}>
                    Open issue
                  </a>
                </li>
              )}
            </For>
          </ul>
        </section>
      </Show>

      <section class="map-selected-section">
        <h3>Structural and coverage evidence</h3>
        <ul class="map-selected-evidence">
          <For each={structuralEvidence()}>
            {(evidence) => (
              <li class={`is-${evidence.kind}`}>
                <strong>{mapEvidenceLabel(evidence)}</strong>
                <p>{evidence.detail}</p>
              </li>
            )}
          </For>
        </ul>
      </section>
    </>
  );
}

function severityLabel(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
